import { render } from "./NavItems.vue?vue&type=template&id=740f57f1&scoped=true&ts=true"
import script from "./NavItems.vue?vue&type=script&lang=ts"
export * from "./NavItems.vue?vue&type=script&lang=ts"

import "./NavItems.scss?vue&type=style&index=0&id=740f57f1&lang=scss&scoped=true"

import exportComponent from "C:\\WORK\\MAPO\\hrm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740f57f1"]])

export default __exports__